module.exports = __webpack_public_path__ + "img/infoIcon01.2b17911e.svg";